import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { Sidebar } from '@resurs/midas-react'
import config from '../../../../../config'
import LeftSideStructure from '../shared/Structure'
import { Authorities } from '../../../models/authorities'
import { getUserNews } from '../../../store/actions/news-actions'
import { getText } from '../../TextLabels'
import { useInterval, useOnMount } from '../../../util/utility-hooks'
import logo from '../../../assets/img/logo.svg'
import logomark from '../../../assets/img/logomark.svg'
import AdvanceSettingsModal from './AdvanceSettingsModal'

const SidebarNavLink = ({ children, to }) => (
  <NavLink to={to}>{children}</NavLink>
)

const SideNav = ({
  auth,
  userNews,
  hasBonusCheckSupport,
  router,
  onMenuOpen,
  isMenuOpen,
  storeInfo,
  ...props
}) => {
  const [hasNewsError, setHasNewsError] = useState(
    !!userNews && !!userNews.error,
  )
  const [numberOfUnreadNewsItems, setNumberOfUnreadNewsItems] = useState(0)
  const [isBonusChecksActivated, setBonusChecksActivated] = useState(false)

  const fetchUserNews = () =>
    auth.isLoggedIn && !auth.selectStore && props.getUserNews()

  useOnMount(() => fetchUserNews())

  useInterval(() => fetchUserNews(), config.pollIntervalNews)

  const { name: userName, authorities = [], role } = auth
  const {
    id: storeId,
    name: storeName,
    accountSystemStoreId,
    bonusChecksActivated,
  } = storeInfo.currentStore || {}
  const {
    id: representativeId,
    country: countryCode,
    delayedPaymentEnabled,
  } = storeInfo.currentRepresentative || {}

  const getFooter = () => {
    return (
      <div style={{ minHeight: '50px' }}>
        <strong>{userName}</strong>
        <br />
        {storeName && accountSystemStoreId && (
          <div>
            <span>{storeName}</span>
            <br />
            <span>
              {getText('menu.footer.storeNumber', accountSystemStoreId)}
            </span>
          </div>
        )}
      </div>
    )
  }

  useEffect(() => {
    setHasNewsError(!!userNews && !!userNews.error)
  }, [userNews])

  useEffect(() => {
    if (!!userNews && !userNews.error) {
      setNumberOfUnreadNewsItems(
        userNews.articles.filter(({ acknowledged }) => !acknowledged).length,
      )
    }
  }, [userNews])

  useEffect(() => {
    setBonusChecksActivated(hasBonusCheckSupport && !!bonusChecksActivated)
  }, [hasBonusCheckSupport, storeInfo])

  return (
    <Sidebar
      navLinkComp={SidebarNavLink}
      isOpen={onMenuOpen}
      setClosed={isMenuOpen}
      top={
        <NavLink to="/">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              height: !isMenuOpen ? '47px' : '68px',
              paddingLeft: !isMenuOpen ? '1.5rem' : '1.8rem',
              overflow: 'hidden',
            }}
          >
            {!isMenuOpen ? (
              <img
                alt="logomark"
                style={{
                  width: '30px',
                }}
                src={logomark}
              />
            ) : (
              <img
                alt="logo"
                style={{
                  width: '120px',
                }}
                src={logo}
              />
            )}
          </div>
        </NavLink>
      }
      values={LeftSideStructure(
        authorities,
        role,
        router,
        numberOfUnreadNewsItems,
        hasNewsError,
        isBonusChecksActivated,
        storeId,
        representativeId,
        countryCode,
        delayedPaymentEnabled,
      )}
      footer={{
        icon: 'midasUser1',
        tooltip: userName,
        value: (
          <>
            {auth.authorities.indexOf(Authorities.CHANGE_USER_PROPERTIES) >=
            0 ? (
              <NavLink to="/profile">{getFooter()}</NavLink>
            ) : (
              getFooter()
            )}
            <AdvanceSettingsModal />
          </>
        ),
      }}
    />
  )
}

SideNav.propTypes = {
  auth: PropTypes.object.isRequired,
  storeInfo: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  onMenuOpen: PropTypes.func.isRequired,
  isMenuOpen: PropTypes.bool,
  getUserNews: PropTypes.func.isRequired,
  userNews: PropTypes.object,
  hasBonusCheckSupport: PropTypes.bool.isRequired,
}

SideNav.defaultProps = {
  isMenuOpen: false,
  userNews: null,
}

const mapStateToProps = state => ({
  auth: state.auth,
  storeInfo: state.storeInfo,
  userNews: state.news.userNews,
  router: state.router,
  hasBonusCheckSupport: state.bonusCheck.hasBonusCheckSupport,
})

const mapDispatchToProps = dispatch => ({
  getUserNews: () => {
    dispatch(getUserNews())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(SideNav)
